export default "__VITE_ASSET__DdD78q6E__"